
import { defineComponent, PropType } from 'vue';

type TimeLineItem = {
    _id:string;
    title:string;
    tag:string;
    type?:string;
    color?:string;
    htmlMode?:boolean;
    brief?:string
}

const presetReg = /purple|orange|yellow/;

export default defineComponent({
    props: {
        items: {
            type: Array as PropType<Array<TimeLineItem> >,
            required: true
        },
        hasTitle: {
            type: Boolean,
            default: true
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        click (id:string) {
            return true;
        }
    },
    setup (props, { emit }) {
        const handleClick = (item:TimeLineItem) => {
            emit('click', item._id);
        };

        const getColorClass = (color = '') => {
            return presetReg.test(color) ? color : '';
        };

        const getStyle = (item:TimeLineItem) => {
            const color = item.color || '';
            if (presetReg.test(color)) {
                return item.type === 'star'
                    ? { stroke: color }
                    : { border: `2px solid ${color}` };
            }
            return {};
        };

        return {
            handleClick,
            getColorClass,
            getStyle
        };
    }
});
